import { Alert, AlertTitle, Typography } from "@mui/material";
import { LinearProgress, useTranslate } from "react-admin";

import { GenerateDocumentProgressType } from "./GenerateDocumentDialogButton.types";

type GenerateDocumentProgressBarPropsType = {
  progress?: GenerateDocumentProgressType;
};

export default function GenerateDocumentProgressBar(props: GenerateDocumentProgressBarPropsType) {
  const { progress } = props;
  const translate = useTranslate();

  const getInfoAlertText = (progress: GenerateDocumentProgressType) => {
    const { current, total, otherPending } = progress;
    const i18nPrefix = "resources.document_templates.notification";

    if (current === 0 && otherPending) {
      return translate(`${i18nPrefix}.generation_other_pending`, { smart_count: otherPending });
    } else {
      let text = translate(`${i18nPrefix}.generation_finished`, { smart_count: total });

      if (current < total) {
        text = translate(`${i18nPrefix}.generation_in_progress`, { smart_count: total });
      }

      return `${text} ${current} / ${total}`;
    }
  };

  if (!progress) return <LinearProgress />;

  if (progress.current === progress.total) {
    return null;
  }

  if (progress.error) {
    return (
      <Alert severity="error" sx={{ width: "100%" }}>
        <AlertTitle>
          {translate("resources.document_templates.notification.generation_error", { smart_count: progress.total })}
        </AlertTitle>

        {progress.error}
      </Alert>
    );
  }

  return (
    <Alert severity="info" sx={{ width: "100%", "& .MuiAlert-message": { flex: 1 } }}>
      <Typography>{getInfoAlertText(progress)}</Typography>

      <LinearProgress
        timeout={0}
        variant="determinate"
        sx={{ width: "100%" }}
        value={(progress.current / progress.total) * 100}
      />
    </Alert>
  );
}
